package com.sddamico.draftmachine.models

import com.sddamico.draftmachine.data.DraftStatus
import kotlinx.serialization.Serializable

// jsMain mirror of jvmMain models/DraftLotteryModels.kt — keep the two in sync.

/**
 * Lottery configuration for a draft. [entries] carries EVERY draft team in the LM's base order
 * (list order = base order); only entries with a non-null [LotteryConfigEntry.weight] are in the
 * draw — the rest hold their round-1 slots below the lottery line.
 */
@Serializable
data class SaveLotteryConfigRequest(
  val draftId: String,
  val lotterySize: Int,
  val entries: List<LotteryConfigEntry>,
)

@Serializable
data class LotteryConfigEntry(
  val teamId: String,
  val weight: Int? = null,
)

@Serializable
data class LotteryActionRequest(
  val draftId: String,
)

/** One team's lottery row. drawSlot/drawnNumber are masked (null) until that draw is revealed. */
@Serializable
data class LotteryEntryResponse(
  val teamId: String,
  val teamName: String,
  val ownerName: String,
  val baseOrder: Int,
  val weight: Int? = null,
  val drawSlot: Int? = null,
  val drawnNumber: Int? = null,
)

/** Full lottery state plus enough draft context to rehydrate the wizard's resume flow in one GET. */
@Serializable
data class LotteryStateResponse(
  val draftId: String,
  val lotterySize: Int,
  val revealedCount: Int,
  val committed: Boolean,
  val entries: List<LotteryEntryResponse>,
  val rounds: Int,
  val draftStatus: DraftStatus,
  val leagueName: String? = null,
)
